import { combineReducers, Reducer, AnyAction } from 'redux';
import IAuthState from '../lib/auth/types';
import ISteps from './signup-workflow/types';
import authReducer from '../lib/auth/reducers';
import signupReducer from './signup-workflow/reducers';
import signUpReducer, { InitialStateType } from './signup';
import quizReducer, { QuizStateType } from './quiz';
import paymentReducer, { PaymentStateType } from './payment';
import subscriptionReducer, { SubscriptionStateType } from './subscription';
import reactivationReducer, { ReactivationStateType } from './reactivation';

export interface IAppState {
  auth: IAuthState;
  signupWorkflow: ISteps;
  signUp: InitialStateType;
  quiz: QuizStateType;
  payment: PaymentStateType;
  subscription: SubscriptionStateType;
  reactivation: ReactivationStateType;
}

const createRootReducer = (): Reducer<
  {
    auth: IAuthState;
    signupWorkflow: ISteps;
    signUp: InitialStateType;
    quiz: QuizStateType;
    payment: PaymentStateType;
    subscription: SubscriptionStateType;
    reactivation: ReactivationStateType;
  },
  AnyAction
> =>
  combineReducers({
    auth: authReducer,
    signupWorkflow: signupReducer,
    signUp: signUpReducer,
    quiz: quizReducer,
    payment: paymentReducer,
    subscription: subscriptionReducer,
    reactivation: reactivationReducer,
  }) as Reducer<
    {
      auth: IAuthState;
      signupWorkflow: ISteps;
      signUp: InitialStateType;
      quiz: QuizStateType;
      payment: PaymentStateType;
      subscription: SubscriptionStateType;
      reactivation: ReactivationStateType;
    },
    AnyAction
  >;

export default createRootReducer;
